import { models } from "types/api/viewModels.ts";
import { AvailabilityStatus } from "types/declarations/enums.ts";

type MerchandiseInventorySource = Pick<
	models["MerchandiseProductViewModel"],
	"availabilityStatus" | "quantityAvailable"
>;

export type MerchandiseInventoryStatus = "none" | "in-stock" | "limited-stock" | "backordered" | "out-of-stock";

export const getMerchandiseInventoryStatus = (
	product: MerchandiseInventorySource | null | undefined
): MerchandiseInventoryStatus => {
	if (!product?.availabilityStatus) {
		return "none";
	}

	switch (product.availabilityStatus) {
		case AvailabilityStatus.InStock:
			return "in-stock";
		case AvailabilityStatus.LimitedStock:
			return "limited-stock";
		case AvailabilityStatus.Backordered:
			return "backordered";
		case AvailabilityStatus.OutOfStock:
			return "out-of-stock";
		default:
			return "none";
	}
};

export const getMerchandiseInventoryDisplay = (product: MerchandiseInventorySource | null | undefined) => {
	const quantityAvailable = product?.quantityAvailable ?? 0;

	switch (getMerchandiseInventoryStatus(product)) {
		case "in-stock":
			return "";
		case "limited-stock":
			return `Limited Stock: ${quantityAvailable}`;
		case "backordered":
			return "On Backorder";
		case "out-of-stock":
			return "Out of Stock";
		default:
			return null;
	}
};

export const canAddMerchandiseToCart = (product: MerchandiseInventorySource | null | undefined) =>
	Boolean(product) && getMerchandiseInventoryStatus(product) !== "out-of-stock";
